
// import { bindingMobile, thirdGrant, thirdLogin } from "@/api/login";
// import { setToken } from "@/utils/token";
import md5 from 'js-md5'
import defaultSettings from '@/settings'
export default {
    data() {
        return {
            pact: defaultSettings.pactUrl,
            show: true,
            submitLoading: false,
            ruleForm: {
                mobile: '',
                password: ''
            },
            count: 0,
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                        required: true,
                        message: '请输入正确的手机号',
                        trigger: 'blur'
                    }
                ],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            checked: false,
            loginSate: false,
            regSate: true,
            code: '',
            qq_openid: '',
            loading: true,
            isBingPhone: false,
            regBoxShow: false
        }
    },

    mounted() {
        const code = this.getQueryString('code')
        sessionStorage.setItem('qqCode', code)
        this.code = code || sessionStorage.getItem('qqCode')
        setTimeout(() => {
            this.getQQCode()
        }, 500)
    },
    methods: {
        openHrf() {
            this.checked = !this.checked
        },
        getQueryString(variable) {
            var query = window.location.href.split('?')[1]
            if (query) {
                var vars = query.split('&')
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split('=')
                    if (pair[0] == variable) {
                        return pair[1]
                    }
                }
            }
        },
        getQQCode() {
            let params = {
                action: {
                    authType: 'qq',
                    code: this.code
                }
            }
            this.$api.thirdGrant(params).then((res) => {
                if (res.success) {
                    var data = res.data
                    this.qq_openid = data.openid
                    // 通过微信扫码但没有绑定手机
                    if (data.isBingPhone === false) {
                        this.loading = false
                        this.$message.success('QQ授权成功，为了您的安全请绑定手机号码完成注册')
                    } else {
                        // 如果绑定了手机就直接登录
                        this.ScanCodeLogin()
                    }
                } else {
                    this.$confirm('出错了，请重新进行QQ授权...', '警告', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    })
                        .then(() => {
                            this.$router.push({ name: 'login', params: { openCode: false } })
                        })
                        .catch(() => {
                            this.$router.push({ name: 'login', params: { openCode: false } })
                        })
                }
            })
        },
        // QQ扫码登录，获取用户信息
        ScanCodeLogin() {
            let params = {
                openid: this.qq_openid,
                authType: 'qq'
            }
            this.$api.thirdLogin(params).then((res) => {
                if (res.success) {
                    window.localStorage.setItem('userinfo', JSON.stringify(res.data))
                    const tokenId = 'user' + res.data.id + 'logined'
                    this.$store.commit('SET_TOKEN', tokenId)
                    // setToken(tokenId); //用户id已登录
                    this.$cookies.set('pzdsCookie', tokenId)
                    this.$router.push({ path: '/' }) //跳到首页
                    this.$message.success('登录成功')
                } else {
                    this.$message.error(res.info)
                    // 5秒后重新跳转到登录页
                    setTimeout(() => {
                        this.$router.push({ path: '/login' })
                    }, 5000)
                }
            })
        },
        getCode() {
            const TIME_COUNT = 60
            if (!this.timer) {
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--
                    } else {
                        this.show = true
                        clearInterval(this.timer)
                        this.timer = null
                        this.submitLoading = false
                    }
                }, 1000)
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.checked === false) {
                        this.$message.warning('请阅读并勾选《盼之代售服务协议》')
                        return false
                    } else {
                        this.submitLoading = true
                        let params = {
                            action: {
                                authType: 'qq',
                                mobile: this.ruleForm.mobile,
                                password: md5(this.ruleForm.password),
                                openid: this.qq_openid
                            }
                        }
                        this.$api
                            .bindingMobile(params)
                            .then((res) => {
                                this.submitLoading = false
                                if (res.success) {
                                    //通过openid登录一下
                                    this.ScanCodeLogin()
                                } else {
                                    this.$confirm(res.info, '提示', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    })
                                        .then(() => {
                                            if (res.code === 'USER_NOT_EXIST') {
                                                this.$router.push({ name: 'registered' })
                                            } else {
                                                this.$router.push({ name: 'login' })
                                            }
                                        })
                                        .catch(() => {
                                            this.$refs.phone.focus()
                                        })
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false
                            })
                    }
                } else {
                    return false
                }
            })
        },
        register() {
            if (this.ruleForm.mobile === '') {
                this.$message.error('请输入手机号')
                this.$refs.phone.focus()
                return false
            } else {
                let params = {
                    action: {
                        mobile: this.ruleForm.mobile,
                        smsTemplate: 'login'
                    }
                }
                this.$store.dispatch('account/UserSendSms', params).then((res) => {
                    if (res.success) {
                        this.$message.success('验证码已发送，请注意查收')
                        this.getCode()
                        return false
                    } else {
                        this.$message.warning(res.info)
                    }
                })
            }
        },
        returnBang() {
            this.isBingPhone = !this.isBingPhone
        },
        regBoxReturnBang() {
            this.isBingPhone = !this.isBingPhone
            this.regBoxShow = false
        },
        // 登录并绑定
        bindLogin() {
            this.isBingPhone = true
            this.regBoxShow = false
        },
        // 注册并绑定
        bindRegistered() {
            this.regBoxShow = true
            this.isBingPhone = true
        },
        // 取消
        bindClose() {
            this.$router.push({ name: 'login' })
            sessionStorage.removeItem('qqCode')
            sessionStorage.removeItem('wxCode')
        }
    }
}
